import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTopics } from "../../context/TopicContext";
import styled from "styled-components";
import { Pill, PillGrid, EmptyState } from "../common/Pill";
import theme from "../../styles/theme";

const Container = styled.div`
  width: 100%;
  padding-bottom: ${theme.space.lg};
`;

const Status = styled.p`
  margin: ${theme.space.xl} auto;
  text-align: center;
  color: ${theme.color.textFaint};
  font-size: ${theme.font.md};
`;

const TopicList = () => {
  const { topics, getTopics, loading } = useTopics();

  useEffect(() => {
    if (!topics.length) {
      getTopics();
    }
  }, [getTopics, topics.length]);

  const sortedTopics = [...(topics || [])].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  if (loading) {
    return <Status>Loading topics…</Status>;
  }

  // No page heading here: the navbar brand already reads "Topics", and every
  // pixel of vertical space is reading room during an interview.
  return (
    <Container>
      {sortedTopics.length === 0 ? (
        <EmptyState>
          No topics yet. Use the + button above to create your first one.
        </EmptyState>
      ) : (
        <PillGrid>
          {sortedTopics.map((topic) => (
            <Pill key={topic.id} as={Link} to={`/topic/${topic.id}`}>
              {topic.name}
            </Pill>
          ))}
        </PillGrid>
      )}
    </Container>
  );
};

export default TopicList;
